export enum TIME_RANGE_REQUEST_TYPE {
    PREVIOUS,
    NEXT,
}
